import React from "react";
import PropTypes from "prop-types";

const Icon = ({ pathFill, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 25"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM12 20.5C7.59 20.5 4 16.91 4 12.5C4 8.09 7.59 4.5 12 4.5C16.41 4.5 20 8.09 20 12.5C20 16.91 16.41 20.5 12 20.5ZM15.88 8.79L10 14.67L8.12 12.79C7.93317 12.6027 7.67952 12.4975 7.415 12.4975C7.15048 12.4975 6.89683 12.6027 6.71 12.79C6.32 13.18 6.32 13.81 6.71 14.2L9.3 16.79C9.69 17.18 10.32 17.18 10.71 16.79L17.3 10.2C17.69 9.81 17.69 9.18 17.3 8.79C16.91 8.4 16.27 8.4 15.88 8.79Z"
        fill={pathFill}
      />
    </svg>
  );
};

Icon.propTypes = {
  pathFill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Icon.defaultProps = {
  pathFill: "#FF8B22",
  width: "24",
  height: "25"
};

export default Icon;
